import { TopicsTreeMode } from '../../topics-tree-mode';

export enum AssetTreeStudentModeBadgeType {
  Proficiency = 'proficiency',
  Completion = 'completion',
  Weight = 'weight',
}

export enum AssetTreeAdminModeBadgeType {
  AssetStatus = 'assetStatus',
}

export type AssetTreeBadgeType = AssetTreeStudentModeBadgeType | AssetTreeAdminModeBadgeType;

export enum AssetTreeSortType {
  Default = 'default',
  Alphabetically = 'alphabetically',
}

export const SORT_TYPE_TO_LABEL: Record<AssetTreeSortType, string> = {
  [AssetTreeSortType.Default]: 'Default',
  [AssetTreeSortType.Alphabetically]: 'Alphabetically',
};

export const BADGE_TYPE_TO_LABEL_KEY: Record<AssetTreeBadgeType, string> = {
  [AssetTreeAdminModeBadgeType.AssetStatus]: 'examdojo.status',
  [AssetTreeStudentModeBadgeType.Proficiency]: 'examdojo.proficiency',
  [AssetTreeStudentModeBadgeType.Completion]: 'examdojo.completion',
  [AssetTreeStudentModeBadgeType.Weight]: 'examdojo.weight',
};

export const TOPICS_TREE_MODE_TO_DEFAULT_BADGE_TYPE: Record<TopicsTreeMode, AssetTreeBadgeType> = {
  student: AssetTreeStudentModeBadgeType.Proficiency,
  admin: AssetTreeAdminModeBadgeType.AssetStatus,
};
